import { Navigate, RouteObject } from 'react-router-dom';
import { QuizletVersionConfig } from './quizlet-config';
import QuizletUnifiedWrapper from './quizlet-unified-wrapper.page';
import QuizletUnifiedResults from './quizlet-unified-results.page';

/**
 * Factory function to generate routes for any quizlet version
 * @param config - Configuration for the specific quizlet version
 * @returns RouteObject with all necessary routes for the quizlet version
 */
export const createQuizletRoute = (config: QuizletVersionConfig): RouteObject => {
  return {
    path: config.basePath,
    children: [
      {
        index: true,
        element: <Navigate to="questionnaire" replace />,
      },
      {
        path: 'questionnaire',
        element: <QuizletUnifiedWrapper config={config} />,
      },
      {
        path: 'questionnaire/:questionSlug',
        element: <QuizletUnifiedWrapper config={config} />,
      },
      {
        path: 'results',
        element: <QuizletUnifiedResults config={config} />,
      },
    ],
  };
};

/**
 * Generate all quizlet routes from enabled configurations
 * @param configs - Array of quizlet version configurations
 * @returns Array of RouteObjects for all enabled quizlet versions
 */
export const generateAllQuizletRoutes = (configs: QuizletVersionConfig[]): RouteObject[] => {
  return configs
    .filter(config => config.enabled && config.uuid)
    .map(config => createQuizletRoute(config));
};